var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLegoBlock = function SvgLegoBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22.5 7.5V18L12 22.5 1.5 18V7.5L12 12zM12 22.5V12M7.5 4.929 1.5 7.5M16.5 4.929l6 2.571M7.5 3a4.5 1.5 0 1 0 9 0 4.5 1.5 0 1 0-9 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 3v3c0 .828 2.015 1.5 4.5 1.5s4.5-.672 4.5-1.5V3"
  })));
};
export default SvgLegoBlock;